module.exports = __webpack_public_path__ + "static/media/ice13.37d3a546.webp";